import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom'

import { env } from './env'

export const initSentry = () => {
  Sentry.init({
    dsn: env.SENTRY_DSN,
    environment: `${env.MODE}`,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: env.MODE === 'prod' ? 0.1 : 1.0,
    // Session Replay
    replaysSessionSampleRate: env.MODE === 'prod' ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,
  })
}
